// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__bhSjO","tab":"Tabs_tab__oxZ51","active":"Tabs_active__8LDdl"};